import { IField } from '.'
import { US_STATES } from './constants'
import { FormikSelectField } from './formik-select-field'

export const StateSelectField = ({ fieldProps }: { fieldProps: IField }) => (
  <FormikSelectField
    fieldProps={fieldProps}
    options={US_STATES.map(o => ({ label: o.name, key: o.abbreviation, value: o.abbreviation }))}
    getKeyFromOptionValue={value => value}
  />
)
